import { CSSColorEditor } from "./css-color/css-color";
import { CSSFontEditor } from "./css-font";
import { CSSLengthEditor } from "./css-length";
import { CSSPercentageEditor } from "./css-percentage";
import { CSSStringEditor } from "./css-string/css-string";
import { ClickBehaviorEditor } from "./property-click-behavior";
import { CustomCSSEditor } from "./property-custom-css";
import { IconPropertyEditor } from "./property-icon";
import { ImagePropertyEditor } from "./property-image";
import { LottiePropertyEditor } from "./property-lottie";
import { NavigationPropertyEditor } from "./property-navigation";
import { StackPropertyEditor } from "./property-stack";
import { TextPropertyEditor } from "./property-text";
import VideoPropertyEditor from "./property-video";
import { VariableBooleanEditor } from "./variable-boolean";
import { VariableNumberEditor } from "./variable-number";
import { VariableStringEditor } from "./variable-string";
import { DrawerPropertyEditor } from "./property-drawer";
import { InputPropertyEditor } from "./property-input";
export const EditorForValueType = {
    "css-string": CSSStringEditor,
    "css-color": CSSColorEditor,
    "css-length": CSSLengthEditor,
    "css-percentage": CSSPercentageEditor,
    "css-font": CSSFontEditor,
    "property-text": TextPropertyEditor,
    "property-image": ImagePropertyEditor,
    "property-video": VideoPropertyEditor,
    "property-stack": StackPropertyEditor,
    "property-icon": IconPropertyEditor,
    "property-lottie": LottiePropertyEditor,
    "property-navigation": NavigationPropertyEditor,
    "property-drawer": DrawerPropertyEditor,
    "variable-number": VariableNumberEditor,
    "variable-string": VariableStringEditor,
    "variable-boolean": VariableBooleanEditor,
    "property-click-behavior": ClickBehaviorEditor,
    "property-custom-css": CustomCSSEditor,
    "css-background-image": ()=>null,
    "css-box-shadow": ()=>null,
    "css-number-unit": ()=>null,
    "css-backdrop-filter": ()=>null,
    "css-filter": ()=>null,
    "css-transform-rotate": ()=>null,
    "css-transform-scale": ()=>null,
    "css-transform-translate": ()=>null,
    "css-transition": ()=>null,
    "property-input": InputPropertyEditor
};
